import { BookOutlined }        from '@ant-design/icons';
import { InteractionOutlined } from '@ant-design/icons';
import { CrownOutlined }       from '@ant-design/icons';
import { HomeOutlined }        from '@ant-design/icons';
import { TeamOutlined }        from '@ant-design/icons';
import { UserOutlined }        from '@ant-design/icons';
import AdminUserModel          from './models/services/admin/AdminUserModel';
import SubscriptionModel       from './models/services/account/SubscriptionModel';
import AccountModel            from './models/services/account/AccountModel';
import UserModel               from './models/services/account/UserModel';
import EventModel              from './models/services/audit/EventModel';
import { GlobalOutlined }      from '@ant-design/icons';
import MenuModel               from '@models/admin/MenuModel';
import { MenuOutlined }        from '@ant-design/icons';
import SitePageModel           from '@models/admin/SitePageModel';
import { PicLeftOutlined }     from '@ant-design/icons';
import { MailOutlined }        from '@ant-design/icons';
import { DashboardOutlined }   from '@ant-design/icons';
import { CompassOutlined }     from '@ant-design/icons';
import { ProjectOutlined }     from '@ant-design/icons';
import ProjectTemplateModel    from '@models/map/ProjectTemplateModel';

export default [
	{
		label: 'Accueil',
		link: '/',
		icon: <HomeOutlined />,
	},
	{
		label: AccountModel.localize('plural'),
		link: AccountModel.pagePath('list'),
		icon: <TeamOutlined />,
	},
	{
		label: UserModel.localize('plural'),
		link: UserModel.pagePath('list'),
		icon: <UserOutlined />,
	},
	{
		label: AdminUserModel.localize('plural'),
		link: AdminUserModel.pagePath('list'),
		icon: <CrownOutlined />,
	},
	{
		label: SubscriptionModel.localize('plural'),
		link: SubscriptionModel.pagePath('list'),
		icon: <BookOutlined />,
	},
	{
		label: EventModel.localize('plural'),
		link: EventModel.pagePath('list'),
		icon: <InteractionOutlined />,
	},
	{
		label: ProjectTemplateModel.localize('plural'),
		link: ProjectTemplateModel.pagePath('list'),
		icon: <ProjectOutlined />,
	},
	{
		key: 'website',
		label: 'Site public',
		icon: <GlobalOutlined />,
		children: [
			{
				key: '/menus',
				label: MenuModel.localize('plural'),
				link: MenuModel.pagePath('list'),
				icon: <MenuOutlined />,
			},
			{
				key: '/site_pages',
				label: SitePageModel.localize('plural'),
				link: SitePageModel.pagePath('list'),
				icon: <PicLeftOutlined />,
			},
		],
	},
	{
		key: '/mails/',
		label: 'Mails',
		icon: <MailOutlined />,
		children: [
			{
				key: '/mails/account/',
				label: 'Comptes (account)',
				link: '/mails/account/',
				icon: <TeamOutlined />,
			},
			{
				key: '/mails/admin/',
				label: 'Administration (admin)',
				link: '/mails/admin/',
				icon: <DashboardOutlined />,
			},
			{
				key: '/mails/map/',
				label: 'Cartes (map)',
				link: '/mails/map/',
				icon: <CompassOutlined />,
			},
		],
	},
];

export const navigationSettings = [];
